export default {
  'pages.platformSettings.title': '平台设置',
  'pages.platformSettings.tab.branding': '品牌',
  'pages.platformSettings.tab.llm': '默认大模型',
  'pages.platformSettings.tab.storage': '默认存储',
  'pages.platformSettings.tab.quota': '用量限制',
  'pages.platformSettings.tab.features': '平台功能',
  'pages.platformSettings.tab.permissions': '平台权限',
  'pages.platformSettings.subtitle.branding':
    '设置珊瑚礁平台的名称、Logo 与版权信息。',
  'pages.platformSettings.subtitle.llm': '设置平台默认使用的大模型。',
  'pages.platformSettings.subtitle.storage': '设置新建应用时的默认存储策略。',
  'pages.platformSettings.subtitle.quota':
    '设置对所有租户生效的默认额度与上限。',
  'pages.platformSettings.subtitle.features': '开启或关闭平台级功能。',
  'pages.platformSettings.subtitle.permissions':
    '按账号授予平台级角色，租户内不再单独设置角色。',
  'pages.platformSettings.save': '保存',
  'pages.platformSettings.reset': '重置',
  'pages.platformSettings.saveSuccess': '设置已保存',
  'pages.platformSettings.saveFailed': '保存失败，请重试',
  'pages.platformSettings.loadFailed': '平台设置加载失败',
  'pages.platformSettings.retry': '重试',
  'pages.platformSettings.zeroUnlimited': '填 0 表示不限制',
  'pages.platformSettings.branding.title': '平台品牌',
  'pages.platformSettings.branding.description':
    '品牌信息对所有用户生效，包括登录前页面。名称与 Logo 默认显示当前部署在用的值；底部版权留空时沿用各语言的默认配置。',
  'pages.platformSettings.branding.platformName': '平台名称',
  'pages.platformSettings.branding.platformNameExtra':
    '显示在顶栏与浏览器标题中',
  'pages.platformSettings.branding.platformNamePlaceholder': '例如：珊瑚礁',
  'pages.platformSettings.branding.platformNameEn': '英文名称',
  'pages.platformSettings.branding.logoLight': '浅色主题 Logo',
  'pages.platformSettings.branding.logoDark': '深色主题 Logo',
  'pages.platformSettings.branding.favicon': '浏览器标签图标',
  'pages.platformSettings.branding.footerCopyright': '底部版权信息',
  'pages.platformSettings.branding.logoHint':
    '支持 PNG、JPG、SVG、WebP、ICO，不超过 5MB',
  'pages.platformSettings.branding.uploadFailed': '上传失败，请重试',
  'pages.platformSettings.branding.upload': '上传',
  'pages.platformSettings.branding.restoreDefault': '恢复默认',
  'pages.platformSettings.llm.title': '平台默认大模型',
  'pages.platformSettings.llm.description':
    '未单独指定模型的租户与业务应用将使用这里的默认模型。可选项来自「模型广场」中已启用的平台内置模型。',
  'pages.platformSettings.llm.manageModels': '管理模型',
  'pages.platformSettings.llm.loadFailed':
    '模型目录加载失败，仅显示已保存的选择',
  'pages.platformSettings.llm.chatModel': '默认对话模型',
  'pages.platformSettings.llm.embeddingModel': '默认向量模型',
  'pages.platformSettings.llm.notSet': '未设置',
  'pages.platformSettings.llm.unavailableModel': '{ref}（已停用或不存在）',
  'pages.platformSettings.storage.title': '平台默认存储',
  'pages.platformSettings.storage.description':
    '新建业务应用时按以下默认值创建应用存储配置，已有配置不受影响，可在「应用存储配置」中单独调整。',
  'pages.platformSettings.storage.autoProvision': '新建应用时自动创建存储',
  'pages.platformSettings.storage.autoProvisionExtra':
    '关闭后需在「应用存储配置」中手动创建',
  'pages.platformSettings.storage.accessMode': '默认访问模式',
  'pages.platformSettings.storage.accessMode.private': '私有',
  'pages.platformSettings.storage.accessMode.public_read': '公共读',
  'pages.platformSettings.storage.accessMode.public_folder_only':
    '仅公共目录可读',
  'pages.platformSettings.storage.usageEnabled': '默认开启用量统计',
  'pages.platformSettings.quota.title': '租户用量限制',
  'pages.platformSettings.quota.description':
    '对所有租户生效的平台级默认限制。套餐与加购资源包发放的额度会在默认额度之上累加。',
  'pages.platformSettings.quota.defaultTenantTokenQuota': '租户默认 Token 额度',
  'pages.platformSettings.quota.defaultTenantStorageQuotaGb':
    '租户默认存储额度',
  'pages.platformSettings.quota.maxMembersPerTenant': '单租户成员数上限',
  'pages.platformSettings.quota.maxInstalledAppsPerTenant':
    '单租户自助开通应用数上限',
  'pages.platformSettings.quota.defaultQuotaExtra':
    '尚未分配额度的租户首次使用时按此额度起步；填 0 表示不发放默认额度',
  'pages.platformSettings.quota.maxInstalledAppsExtra':
    '只统计租户在应用市场自助开通的免费应用，不含套餐默认应用；填 0 表示不限制',
  'pages.platformSettings.quota.unitPerson': '人',
  'pages.platformSettings.quota.unitApp': '个',
  'pages.platformSettings.features.title': '平台功能',
  'pages.platformSettings.features.aiAssistant': '全局 AI 助手',
  'pages.platformSettings.features.aiAssistantExtra':
    '关闭后所有用户页面右下角不再显示 AI 助手',
  'pages.platformSettings.permissions.user': '账号',
  'pages.platformSettings.permissions.grantedAt': '授权时间',
  'pages.platformSettings.permissions.actions': '操作',
  'pages.platformSettings.permissions.revoke': '撤销',
  'pages.platformSettings.permissions.userRequired': '请选择账号',
  'pages.platformSettings.permissions.userPlaceholder':
    '搜索姓名、用户名、手机号或邮箱',
  'pages.platformSettings.readOnlyHint': '你只有查看权限，不能修改平台设置',
  'pages.platformSettings.permissions.notice':
    '权限按「资源 + 查看/管理」授予给角色，再把角色授予账号；与账号所在租户无关。角色与授权托管在 YeeAuth，变更最多 30 秒生效。',
  'pages.platformSettings.permissions.roles': '角色',
  'pages.platformSettings.permissions.createRole': '新建角色',
  'pages.platformSettings.permissions.builtin': '内置',
  'pages.platformSettings.permissions.rename': '重命名',
  'pages.platformSettings.permissions.deleteRole': '删除',
  'pages.platformSettings.permissions.deleteRoleConfirm':
    '确认删除角色「{name}」？持有该角色的账号会失去对应权限。',
  'pages.platformSettings.permissions.deleteRoleSuccess': '角色已删除',
  'pages.platformSettings.permissions.tabPermissions': '权限',
  'pages.platformSettings.permissions.tabMembers': '成员',
  'pages.platformSettings.permissions.adminLocked':
    '平台管理员拥有全部权限，不能修改',
  'pages.platformSettings.permissions.resource': '资源',
  'pages.platformSettings.permissions.action.read': '查看',
  'pages.platformSettings.permissions.action.manage': '管理',
  'pages.platformSettings.permissions.roleName': '角色名称',
  'pages.platformSettings.permissions.roleNameRequired': '请输入角色名称',
  'pages.platformSettings.permissions.addMember': '添加成员',
  'pages.platformSettings.permissions.empty': '该角色暂无成员',
  'pages.platformSettings.permissions.revokeConfirm':
    '确认将「{name}」移出{role}？',
  'pages.platformSettings.permissions.cannotRevokeSelf':
    '不能把自己移出平台管理员',
  'pages.platformSettings.permissions.grantSuccess': '已添加成员',
  'pages.platformSettings.permissions.grantFailed': '添加失败，请重试',
  'pages.platformSettings.permissions.revokeSuccess': '已移出',
  'pages.platformSettings.permissions.loadFailed': '加载失败',
  'pages.noPlatformPermission.title': '没有平台权限',
  'pages.noPlatformPermission.description':
    '当前账号还没有被授予任何珊瑚礁平台角色，请联系平台管理员授权后重新登录。',
  'pages.noPlatformPermission.logout': '退出登录',
  'pages.platformSettings.permissions.group.applications': '应用',
  'pages.platformSettings.permissions.group.commercial': '营销销售',
  'pages.platformSettings.permissions.group.capabilities': '基础服务',
  'pages.platformSettings.permissions.group.resources': '运维监控',
  'pages.platformSettings.permissions.group.management': '平台管理',
  'pages.platformSettings.permissions.group.settings': '设置',
  'pages.platformSettings.storage.accessMode.inherit':
    '沿用文件管理默认（仅公共目录可读）',
};
